import React, { Component } from 'react';
import { connect } from 'react-redux';
import shared from '../../utils/shared';
import _ from 'lodash';
import { getFileType } from '../../utils/fileHelpers';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import ReactPlayerWrapper from '../Slideshow/ReactPlayerWrapper';
// import ReactPlayer from 'react-player';

class RecentDonors extends Component {

  constructor(props) {
    super(props);
    this._donors = null;

    this.setupDonors();

    this._totalElements = this._donors.length;
    // this._cycleOverrides = this.props.module.contents.cycle_overrides;
    this._currentDuration = 0;
    this._startSlideTime = 0;
    this._paused = false;

    this.state = {
      activeSlide: 0,
      videoVolumes: Array.from(Array(this._donors.length), () => 0),
      module: this.props.module
    }
  }

  setupDonors = () => {
    let donorCategories = this.props.module.contents.recent_donors_configuration;
    let selectedDonors = [];
    if (donorCategories.length > 0) {
      donorCategories.forEach((category, index) => {
        let donorsFound = _.find(this.props.donors.donorCategories, { id: Number(category.donor_category) });
        // console.log("donors Founds", donorsFound);

        if (donorsFound) {
          // First let's find donors that have at least one image.
          let donorsWithImages = _.filter(donorsFound.donors, ((o) => {
            return o.contents.images.length > 0
          }));

          // console.log("Donors With Images", donorsWithImages);

          if (donorsWithImages.length > 0) {
            let sortedDonorsWithImages = _.sortBy(donorsWithImages, ['createdAt']);
            // console.log("sortedDonorsWithImages", sortedDonorsWithImages)
            
            // Select last Donors based on CreatedAt field.
            let quantity = Number(category.donors_qty);
            if (category.donors_qty > sortedDonorsWithImages.length) {
              quantity = sortedDonorsWithImages.length;
            }
            for (let i = sortedDonorsWithImages.length - 1; i >= sortedDonorsWithImages.length - quantity; i--) {
              //sortedDonorsWithImages[i];
              selectedDonors.push({
                id: sortedDonorsWithImages[i].id,
                name: sortedDonorsWithImages[i].name,
                image: sortedDonorsWithImages[i].contents.images[0],
                cycleTime: category.cycle_time
              });
            }

            // console.log("selectedDonors", selectedDonors);
          }
        }
      })
    }

    this._donors = selectedDonors;
  }

  componentWillMount() {
    shared.checkData(this.props.module);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    this.slideChanged(0);
  }

  componentWillUnmount() {
    this.clearCycleTimeout();
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  // componentDidUpdate(prevProps, prevState){
  // 	if (this.prevProps.idle!==this.props.idle){
  // 		//if video timeout.
  // 	}
  // }

  handleKeyDown = (e) => {
    switch (e.keyCode) {
      // Left Arrow (Previous)
      case 37:
        console.log('left arrow');
        this.clearCycleTimeout();
        this.prevSlide();
        break;
      // Right Arrow (Next)
      case 39:
        console.log('right arrow');
        this.clearCycleTimeout();
        this.nextSlide();
        break;
      // Space (Pause)
      case 32:
        this.clearCycleTimeout();
        let fileType = getFileType(this._donors[this.state.activeSlide].image.file_name);
        if (fileType !== "Image") {
          this._paused = !this._paused;
          this.toggleVideoReproduction(this._paused);
        }
        break;
      default:
        break;
    }
  }

  clearCycleTimeout = () => {
    clearTimeout(this._cycleTimeout);
    this._cycleTimeout = null;
  }

  nextSlide = () => {
    let currentSlide = this.state.activeSlide;
    let nextSlide = 0;

    if (currentSlide < (this._totalElements - 1)) {
      nextSlide = currentSlide + 1;
    }

    this.slideChanged(nextSlide);
  }

  prevSlide = () => {
    let currentSlide = this.state.activeSlide;
    let nextSlide = currentSlide - 1;

    if (currentSlide === 0) {
      nextSlide = this._totalElements - 1;
    }

    this.slideChanged(nextSlide);
  }

  toggleVideoReproduction = (paused) => {
    if (paused === true) {
      console.log('Pause');
      this._pausedOn = new Date().getTime();

      this.setState({
        activeSlide: this.state.activeSlide,
        videoVolumes: this.state.videoVolumes
      });
    } else {
      console.log('Resume');
      let timeLeftToReproduce = this._currentDuration - (this._pausedOn - this._startSlideTime);

      this._currentDuration = timeLeftToReproduce;
      this._startSlideTime = new Date().getTime();

      this.clearCycleTimeout();
      this._cycleTimeout = setTimeout(() => {
        this.nextSlide();
      }, timeLeftToReproduce);

      this.setState({
        activeSlide: this.state.activeSlide,
        videoVolumes: this.state.videoVolumes
      });
    }
  }

  slideChanged = (slide) => {
    if (slide) {
      let timeout = this._donors[slide].cycleTime;
      this._paused = false;
      this._startSlideTime = new Date().getTime();
  
      let fileType = getFileType(this._donors[slide].image.file_name);
      if (fileType === "Image") {
        this.clearCycleTimeout();
        this._cycleTimeout = setTimeout(() => {
          this.nextSlide();
        }, timeout * 1000);
      }
  
      this.setState({
        videoRefsPulled: true,
        activeSlide: slide,
      });
    }
  }

  handleVideoDuration = (duration, delay) => {
    //set our timeout for next slide
    this.clearCycleTimeout();
    this._currentDuration = (duration - delay) * 1000;
    this._cycleTimeout = setTimeout(() => {
      this.nextSlide();
    }, this._currentDuration);
  }

  getSlide = (slide) => {
    let volume = 1;

    if (this.props.idle) {
      volume = 0;
    }

    if (this._donors.length > 0) {
      let innerTile = { width: this.props.screen.screenWidth, height: this.props.screen.screenHeight };
      let fileType = getFileType(this._donors[slide].image.file_name);
  
      if (fileType === "Image") {
        return (<img alt="Slide" onMouseDown={this.preventDrag} className="nodrag" style={innerTile} src={shared.dp(this.props.screen, this._donors[slide].image)} />)
      } else {
        return (<ReactPlayerWrapper
          playing={!this._paused}
          handleVideoDuration={this.handleVideoDuration}
          volume={volume}
          onEnded={this.videoEnded}
          key={slide}
          url={shared.dpath(this.props.screen.mode, this._donors[slide].image.path, this._donors[slide].image.file_name, this.props.screen.webkey)} width={this.props.screen.screenWidth} height={this.props.screen.screenHeight}
        />)
      }
    }
  }

  render() {
    return (
      <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, pointerEvents: "none" }} className="nodrag">
        <CSSTransitionGroup
          component='div'
          transitionName='fastfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.activeSlide} style={{ position: 'absolute', left: 0, top: 0 }}>
            {this.getSlide(this.state.activeSlide)}
          </div>
        </CSSTransitionGroup>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  let dm;
  if (state.options.idleModule === undefined) {
    dm = state.content.dm_active[state.active_module]
  }
  else {
    dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data
  }
  return {
    screen: state.screen,
    donors: state.donors,
    module: dm
  };
};

export default connect(mapStateToProps, null)(RecentDonors);



// WEBPACK FOOTER //
// ./src/Components/Donor/RecentDonors.js